var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72432 5.48624C9.72432 6.06373 9.47928 6.7841 9.03326 7.5895C8.59466 8.38151 8.00044 9.18732 7.39135 9.91808C6.78441 10.6463 6.17541 11.2848 5.71716 11.7421C5.6187 11.8403 5.52739 11.93 5.44478 12.0102C5.36217 11.93 5.27086 11.8403 5.1724 11.7421C4.71415 11.2848 4.10515 10.6463 3.4982 9.91808C2.88911 9.18732 2.2949 8.38151 1.85629 7.5895C1.41028 6.7841 1.16523 6.06373 1.16523 5.48624C1.16523 2.78979 3.14272 0.720457 5.44478 0.720457C7.74684 0.720457 9.72432 2.78979 9.72432 5.48624Z",
    stroke: "white",
    strokeWidth: 1.44091
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.44478,
    cy: 5,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/iconMap.837cf79ff6736a5858fe83a09d5580dd.svg";
export { ForwardRef as ReactComponent };